import { Component, OnInit } from '@angular/core';

import { NgForm } from '@angular/forms';
import { PaRegistrationService } from '../PaRegistration.service';
import { Router } from '@angular/router';
import { WebUserDetails } from '../../../../../shared/models/WebUserDetails';
import { AlertMessages, AlertType } from '../../../../../core/AlertMessages';

@Component({
  selector: 'app-pa-registration',
  templateUrl: './pa-registration.component.html',
  styleUrls: ['./pa-registration.component.css']
})

export class PaRegistrationComponent implements OnInit {

  emailId: string;
  emailIsValid: boolean = true;
  dataSend: boolean = false;
  showAlert: boolean;
  showOverlay: boolean;
  userIsSpace: boolean;
  allUsers: WebUserDetails[];
  username:string="";
  password:string="";
  cPassword:string="";
  constructor(private _service: PaRegistrationService, private router: Router) { }

  ngOnInit() {
    this.emailId =  sessionStorage.getItem("PatientEmail");
  }

  alertClose() {
    setTimeout(() => {
      this.showAlert = false;
      this.router.navigate(['/login']);
    }, 2000);
  }

  checkUsername(emailText: string) {
    if (emailText.includes(' ')) {
      this.userIsSpace = true;
    }
    else {
      this.userIsSpace = false;
      this._service.checkUsernameIfExist(emailText).subscribe((result) => {
        this.emailIsValid = result == 1 ? true : false;
      });
    }
  }

  onRegister(form: NgForm) {
    this.dataSend = true;
    this.showOverlay = true;
    this._service.registerUser(form.value.usern, form.value.pass).subscribe(
    (data: string) => {

      AlertMessages.Show("Success",'Patient registered!',AlertType.Success);
      this.allUsers = JSON.parse(localStorage.getItem('userDetails'));
      this.allUsers.splice(this.allUsers.findIndex(i => i.id == JSON.parse(sessionStorage.getItem('Id'))), 1);
      localStorage.setItem('userDetails', JSON.stringify(this.allUsers));
      sessionStorage.clear();
      this.alertClose();

    },
    (error) => {
      AlertMessages.Show("Failure",'Could not create!',AlertType.Error);

    }).add(() => {
      this.showOverlay = false;
    });
  }
}
